/* eslint-disable react/jsx-props-no-spreading */
/* eslint-disable no-prototype-builtins */
/* eslint-disable jsx-a11y/label-has-associated-control */
import React, { useEffect, useState, useCallback, useContext } from 'react';
import { OverlayProvider } from '@react-aria/overlays';
import PropTypes from 'prop-types';

import uuidv4 from 'PlugAndPlay/_global/js/uuid';
import { UserService } from 'PlugAndPlay/_data-layer/js/global';
import { UserProvider, UserContext } from 'PlugAndPlay/_data-layer/jsx/global';

import Modal from '../../modal/jsx/modal';

function NotificationsSettingsModal(props) {
    const { title, pushNotificationsLabel, fieldsSpec } = props;

    const {
        user,
        isReady,
        isLoading,
        updateUser,
        updateNotifications,
        toggleNotifications,
    } = useContext(UserContext);

    const [supportNotifications, setSupportNotification] = useState(false);
    const [student, setStudent] = useState(null);
    const [pushStatus, setPushStatus] = useState(false);
    const [showModal, setShowModal] = useState(false);

    const toggleModal = useCallback(() => {
        setShowModal(!showModal);
    }, [showModal]);

    // This is to make sure our input fields have unique ids.
    const fieldId = uuidv4();

    // After fetching user object we are setting him in local state.
    useEffect(() => {
        setStudent(user);
    }, [isReady]);

    // Safari and iOS does not support notifications, we wont show panel.
    useEffect(() => {
        const agent = window.navigator.userAgent;
        const iOS = !!agent.match(/iphone/i);
        const safari = !!agent.match(/crios/i);
        const supported = !(iOS || safari);

        setSupportNotification(supported);
    }, [isReady]);

    // Call context and update user notification type preferences.
    const toggleExcludedField = useCallback(
        async (key) => {
            await updateNotifications(key);
            setStudent(user);
        },
        [user]
    );

    // Call context and update user push notifications preferences.
    const togglePushNotifications = useCallback(
        async (key) => {
            setPushStatus(await toggleNotifications(key));
        },
        [user]
    );

    // Update user with new notification preferences.
    const updateNotificationSettings = useCallback(async () => {
        await updateUser(student);
        setShowModal(false);
    }, [student, pushStatus, supportNotifications]);

    const titleId = uuidv4(); // Modal needs a id for the dialog described by

    return (
        <>
            <button
                type="button"
                className="notifications-settings__action"
                onClick={toggleModal}
            >
                Notification settings
            </button>

            {showModal && (
                <Modal
                    onClose={toggleModal}
                    titleId={titleId}
                    className="notifications-settings-modal"
                >
                    <header className="notifications-settings-modal__header">
                        <h1
                            id={titleId}
                            className="notifications-settings-modal__title"
                        >
                            {title}
                        </h1>
                        <button
                            type="button"
                            onClick={toggleModal}
                            className="notifications-settings-modal__header-close"
                        >
                            <svg className="svg-icon">
                                <title>Close modal</title>
                                <use href="#close" />
                            </svg>
                        </button>
                    </header>
                    <div className="custom-form notifications-settings notifications-settings__container">
                        <div className="sq-form-question-answer">
                            <ul>
                                {supportNotifications && (
                                    <li className="notifications-settings__switch-item">
                                        <div className="notifications-settings__notifications-switch">
                                            <svg className="svg-icon notifications-settings__notifications-icon">
                                                <use href="#edify-notification" />
                                            </svg>
                                            <h2 className="notifications-settings__label">
                                                Push notifications
                                            </h2>
                                            <div className="switch">
                                                <input
                                                    className="switch__input"
                                                    type="checkbox"
                                                    id={`switch-input-${fieldId}`}
                                                    onChange={
                                                        togglePushNotifications
                                                    }
                                                    value={pushStatus}
                                                    disabled={!isReady}
                                                    aria-describedby={`switch-status-${fieldId}`}
                                                    aria-labelledby={`switch-description-${fieldId}`}
                                                />
                                                <label
                                                    id={`switch-description-${fieldId}`}
                                                    className="switch__label"
                                                    htmlFor={`switch-input-${fieldId}`}
                                                >
                                                    Toggle push notifications
                                                </label>
                                                <div
                                                    className="switch__marker"
                                                    aria-hidden="true"
                                                />
                                            </div>
                                        </div>
                                        <small
                                            id={`switch-status-${fieldId}`}
                                            className="notifications-settings__description"
                                        >
                                            {' '}
                                            {pushNotificationsLabel}
                                        </small>
                                    </li>
                                )}
                                {isReady &&
                                    fieldsSpec.map(
                                        ({ id, label, description, key }) => {
                                            const labelId = uuidv4();
                                            return (
                                                <li
                                                    key={id}
                                                    className="notifications-settings__switch-item"
                                                >
                                                    <input
                                                        type="checkbox"
                                                        name={id}
                                                        id={`${id}-${labelId}`}
                                                        value={
                                                            student.excludeNotificationTypes &&
                                                            student.excludeNotificationTypes.includes(
                                                                key
                                                            )
                                                        }
                                                        disabled={!isReady}
                                                        onChange={() =>
                                                            toggleExcludedField(
                                                                key
                                                            )
                                                        }
                                                        className="sq-form-field"
                                                        aria-describedby={`${id}-${labelId}-description`}
                                                        aria-labelledby={`${id}-${labelId}-label`}
                                                    />
                                                    <label
                                                        id={`${id}-${labelId}-label`}
                                                        htmlFor={`${id}-${labelId}`}
                                                        className="notifications-settings__label"
                                                    >
                                                        {label}
                                                    </label>
                                                    <small
                                                        id={`${id}-${labelId}-description`}
                                                        className="notifications-settings__description"
                                                    >
                                                        {description}
                                                    </small>
                                                </li>
                                            );
                                        }
                                    )}
                            </ul>
                        </div>
                        <footer className="notifications-settings-modal__footer">
                            <button
                                className="notifications-settings-modal__footer-button"
                                type="button"
                                onClick={updateNotificationSettings}
                                disabled={isLoading}
                            >
                                Update notifications
                                <span className="sr-only">
                                    {` `} Modal will be closed after pressing
                                    update{' '}
                                </span>
                            </button>
                        </footer>
                    </div>
                </Modal>
            )}
        </>
    );
}

export default function NotificationSettings(props) {
    const { userAdapter, documentId } = props;

    const userService = new UserService({ userAdapter });

    return (
        <OverlayProvider>
            <UserProvider
                userService={userService}
                userId={documentId}
                key={documentId}
            >
                <NotificationsSettingsModal {...props} />
            </UserProvider>
        </OverlayProvider>
    );
}

const { string, number, func, oneOfType, arrayOf, shape } = PropTypes;

NotificationSettings.propTypes = {
    title: string,
    documentId: oneOfType([string, number]),
    onDialogClose: func,
    pushNotificationsLabel: string,
    fieldsSpec: arrayOf(
        shape({
            id: string,
            label: string,
            description: string,
            key: string,
        })
    ),
};

NotificationSettings.defaultProps = {
    title: `Notifications settings`,
    documentId: `666`,
    onDialogClose: () => {},
    pushNotificationsLabel: `Most students enable push notifications to stay on top of their studies. This will allow
    you to receive notifications directly to this device.`,
    fieldsSpec: [
        {
            id: `assignment_reminder`,
            label: `Assignment reminder`,
            description: `Remind me about assignments 1 day before their due date.`,
            key: `assignment_reminder`,
        },
        {
            id: `canvas_announcement`,
            label: `Course announcements`,
            description: `Announcements related to one of my courses.`,
            key: `canvas_announcement`,
        },
    ],
};
